import Assignments from './component';
import _routes from './routes';

export const routes = _routes;

export default Assignments;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/index.js